<template>
  <nav class="text-center py-3">
    <h4>
    <router-link to="/">Шмот!</router-link>
    <span v-if="$store.state.user.id"> by </span>
    <router-link to="/profile" v-if="$store.state.user.id">{{ $store.state.user.name }}</router-link>
    </h4>
  </nav>
  <router-view/>
</template>

<script>
import axios from "axios";

export default {
  mounted() {
    if (localStorage.getItem('token')) {
      axios.defaults.headers.common['Token'] = 'Bearer ' + localStorage.getItem('token');
      //this.$store.commit('logIn', localStorage.getItem('token'));
      axios.post('/api.php?action=login')
          .then(response => {
            this.$store.commit('user', response.data);
            //router.push('/');
          })
          .catch(function () {
            localStorage.removeItem('token');
          });
    }
  }
}
</script>
